module.exports = __webpack_public_path__ + "static/img/1.f4413c0.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/16/eng/1.png
// module id = xMXc
// module chunks = 0